import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import { categories, icons, images, products, videoProducts } from "../Data";
import Navbar from "../components/Navbar";
import ProductCard from "../components/ProductCard";
import CategoryCard from "../components/CategoryCard";
import VideoCard from "../components/VideoCard";
import Footer from "../components/Footer";

const imageData = [
  images.hero1,
  images.hero2,
  images.hero3,
  images.hero4,
  images.hero5,
  images.hero6,
  images.hero6,
  images.hero7,
  images.hero7,
  images.hero8,
  images.hero9,
  images.hero10,
  images.hero11,
];

const Home = () => {
  const swiperstatus = useRef();

  const [swiperIcon, setSwiperIcon] = useState(true);

  function play() {
    const s = swiperstatus.current.swiper;
    if (s.autoplay.running) {
      s.autoplay.stop();
    } else {
      s.autoplay.start();
    }

    setSwiperIcon(s.autoplay.running);
  }
  return (
    <>
      <Navbar />
      <div className="mt-[110px]"></div>

      {/* hero */}

      <div className="area flex justify-stretch gap-8">
        {/* first col */}
        <div className="hidden lg:flex flex-col basis-[25%] gap-8">
          <div className="relative rounded-2xl overflow-hidden">
            <img src={imageData[0]} className="w-full h-full object-cover" />
            <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[60%] pl-4">
              <h2 className="xl:text-2xl text-lg font-bold">
                School supplies up to 50% off
              </h2>

              <div>
                <a className="underline">Shop Deals</a>
              </div>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden">
            <img src={imageData[3]} className="w-full h-full object-cover" />
            <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[90%] pl-4">
              <h2 className="xl:text-2xl text-lg font-bold">
                Huge savings on sporting goods
              </h2>
              <div>
                <a className="underline">Shop Deals</a>
              </div>
            </div>
          </div>
          <div className=" relative rounded-2xl overflow-hidden">
            <img src={imageData[2]} className="w-full h-full object-cover" />
            <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[70%] pl-4">
              <h2 className="xl:text-2xl text-lg font-bold">
                Up to 20% off sports
              </h2>
              <div>
                <a className="underline">Shop Deals</a>
              </div>
            </div>
          </div>
        </div>
        {/* second col */}

        <div className="flex flex-col m-auto lg:basis-[50%]   gap-8">
          {/* swiper */}
          <div className="rounded-2xl overflow-hidden relative">
            <Swiper
              className="max-w-[794px]"
              ref={swiperstatus}
              slidesPerView="auto"
              loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: true,
              }}
              modules={[Autoplay]}
            >
              <span
                onClick={play}
                className="absolute bottom-10 bg-white rounded-full right-10 z-10 p-2  cursor-pointer"
              >
                {swiperIcon ? icons.pause : icons.play}
              </span>

              <SwiperSlide className="m-auto">
                <img src={imageData[1]} className="w-ful h-full object-cover" />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={imageData[imageData.length - 1]}
                  className="w-ful h-full object-cover"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={imageData[imageData.length - 2]}
                  className="w-ful h-full object-cover"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={imageData[imageData.length - 3]}
                  className="w-ful h-full object-cover"
                />
              </SwiperSlide>
            </Swiper>
          </div>

          <div className="hidden lg:flex gap-8">
            <div className=" relative rounded-2xl flex gap-8 overflow-hidden">
              <img src={imageData[4]} className="w-full h-full object-cover" />
              <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[70%] pl-4">
                <h2 className="xl:text-2xl text-lg font-bold">
                  Plays up to 50% off
                </h2>
                <div>
                  <a className="underline">Shop Deals</a>
                </div>
              </div>
            </div>
            <div className=" relative rounded-2xl flex gap-8 overflow-hidden">
              <img src={imageData[5]} className="w-full h-full object-cover" />
              <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[70%] pl-4">
                <h2 className="xl:text-2xl text-lg font-bold">
                  Baby Toys up to 50% off
                </h2>
                <div>
                  <a className="underline">Shop Deals</a>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-2xl relative after:absolute after:top-full after:content-['asdadasssssssssssssssss'] overflow-hidden flex items-center justify-between">
            <div className="flex flex-col gap-8 basis-[50%]">
              <div>
                <div className="flex items-center gap-2">
                  <img className="max-w-[80px]" src={images.logo} />
                  <h2 className="font-semibold text-nowrap">Limited time</h2>
                </div>
                <h2 className="md:text-2xl font-bold">
                  Get 50% off annual Walmart+ membership
                </h2>
              </div>
              <div>
                <a className="underline">Claim offer</a>
              </div>
            </div>
            <div>
              <img
                src={images.discount}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
        {/* third col */}
        <div className="hidden lg:flex flex-col basis-[25%] gap-8">
          <div className=" relative rounded-2xl overflow-hidden">
            <img src={imageData[7]} className="w-full h-full object-cover" />
            <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[60%] pl-4">
              <h2 className="xl:text-2xl text-lg font-bold">
                TVs up to 25% off
              </h2>
              <div>
                <a className="underline">Shop Deals</a>
              </div>
            </div>
          </div>
          <div className=" relative rounded-2xl overflow-hidden">
            <img src={imageData[2]} className="w-full h-full object-cover" />
            <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[90%] pl-4">
              <h2 className="xl:text-2xl text-lg font-bold">
                Up to 30% off food—that’s huge
              </h2>
              <div>
                <a className="underline">Shop Deals</a>
              </div>
            </div>
          </div>
          <div className=" relative rounded-2xl overflow-hidden">
            <img src={imageData[9]} className="w-full h-full object-cover" />
            <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[50%] pl-4">
              <h2 className="xl:text-2xl text-lg font-bold">
                Floor care up to 35% off
              </h2>
              <div>
                <a className="underline">Shop Deals</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* shop deals */}

      <div className="area">
        <div className="flex items-center justify-between my-4">
          <div className="font-bold text-2xl ">Shop Deals</div>
          <div className="underline text-sm">View all</div>
        </div>
        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={30}
          slidesPerView="auto"
          slidesPerGroupAuto
          className="mySwiper"
        >
          {products.map((p, i) => (
            <SwiperSlide key={i} style={{ width: "220px" }}>
              <ProductCard {...p} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* new section */}

      <div className="area flex flex-wrap lg:flex-nowrap items-start gap-8">
        <div className="lg:basis-[50%] relative w-full rounded-lg overflow-hidden">
          <img src={images.left1} alt="" className="w-full object-cover" />
          <div className="p-2 absolute inset-0 flex flex-col justify-between w-[60%] pl-4">
            <div className="flex flex-col md:gap-5 gap-2">
              <h2 className="text sm:font-bold text-[#001E60]">
                Perfumes fragrances
              </h2>
              <h2 className="2xl:text-5xl xl:text-3xl sm:text-xl font-bold text-[#001E60]">
                Victoria's Secret faves
              </h2>
              <a className="border-black w-fit rounded-full bg-white font-semibold text-sm border px-3 py-1">
                Shop Deals
              </a>
            </div>
            <div className="flex flex-col font-bold text-[#001E60]">
              <div className="mb-[-10px]">From</div>
              <div className="flex items-center">
                <span className="md:text-4xl mb-4">$</span>
                <span className="md:text-6xl text-3xl">6</span>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[50%] w-full">
          <div className="flex items-start bg-gray-50 mb-4 justify-between">
            <div className="font-bold text-2xl flex flex-col ">
              <span>From Becky G & Alejandra</span>
              <span className="text-[#656565] text-sm font-normal">
                A new home collab by Mainstays.
              </span>
            </div>
            <div className="underline text-sm">View all</div>
          </div>
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={50}
            slidesPerView="auto"
            slidesPerGroupAuto
            className="mySwiper"
          >
            {products.map((p, i) => (
              <SwiperSlide key={i} style={{ width: "220px" }}>
                <ProductCard {...p} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* new section */}

      <div className="area flex flex-wrap lg:flex-nowrap items-start gap-8">
        <div className="lg:w-[50%] w-full order-1 lg:order-first">
          <div className="flex items-start bg-gray-50 mb-4 justify-between">
            <div className="font-bold text-2xl flex flex-col ">
              <span>From Becky G & Alejandra</span>
              <span className="text-[#656565] text-sm font-normal">
                A new home collab by Mainstays.
              </span>
            </div>
            <div className="underline text-sm">View all</div>
          </div>
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={50}
            slidesPerView="auto"
            slidesPerGroupAuto
            className="mySwiper"
          >
            {products.map((p, i) => (
              <SwiperSlide key={i} style={{ width: "220px" }}>
                <ProductCard {...p} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="lg:basis-[50%] relative w-full rounded-lg overflow-hidden">
          <img src={images.right1} alt="" className="w-full object-cover" />
          <div className="p-2 absolute inset-0 flex flex-col justify-between w-[60%] pl-4">
            <div className="flex flex-col md:gap-5 gap-2">
              <h2 className="text sm:font-bold text-[#001E60]">
                A new home collection
              </h2>
              <h2 className="2xl:text-5xl xl:text-3xl sm:text-xl font-bold text-[#001E60]">
                Mainstays by Becky G & Alejandra
              </h2>
              <a className="border-black w-fit rounded-full bg-white font-semibold text-sm border px-3 py-1">
                Shop Deals
              </a>
            </div>
            <div className="flex flex-col font-bold text-[#001E60]">
              <div className="mb-[-10px]">From</div>
              <div className="flex items-center">
                <span className="md:text-4xl mb-4">$</span>
                <span className="md:text-6xl text-3xl">6</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* categoies */}

      <div className="area">
        <div className="flex items-center justify-between my-4">
          <div className="font-bold text-2xl ">Get it all right here</div>
          <div className="underline text-sm">View all</div>
        </div>
        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={50}
          slidesPerView="auto"
          slidesPerGroupAuto
          className="mySwiper"
          id="categoryswiper"
        >
          {categories.map((p, i) => (
            <SwiperSlide key={i} style={{ width: "100px" }}>
              <CategoryCard {...p} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* grid */}

      <div className="area flex justify-center flex-wrap lg:flex-nowrap gap-8">
        <div className="relative rounded-lg overflow-hidden">
          <img
            src={images.grid1}
            className="w-full h-full object-cover"
            alt=""
          />
          <div className="p-4 absolute inset-0 flex flex-col gap-5  pl-4">
            <h2 className="2xl:text-6xl xl:text-3xl sm:text-xl font-bold text-[#001E60]">
              Show off your HBCU pride
            </h2>

            <div className="mt-6">
              <a className="text-black font-bold bg-white rounded-full border border-black p-1 px-2">
                Shop now
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-8">
          <div className="relative rounded-lg overflow-hidden">
            <img
              src={images.grid2}
              className="w-full h-full object-cover"
              alt=""
            />
            <div className="p-2 absolute inset-0 flex flex-col gap-5 w-[40%] pl-4">
              <div>
                <h2 className="font-bold">Accessibility for all</h2>
                <h2 className="text-xl font-bold">Adaptive at Waltmart</h2>
              </div>
              <div>
                <a className="underline">Shop now</a>
              </div>
            </div>
          </div>
          <div className="flex gap-8 items-stretch">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src={images.grid3}
                className="w-full h-full object-cover"
                alt=""
              />
              <div className="p-2 absolute inset-0 flex flex-col gap-5  pl-4">
                <h2 className="text-xl font-bold">
                  Adaptive school essentials
                </h2>

                <div>
                  <a className="underline">Shop now</a>
                </div>
              </div>
            </div>
            <div className="relative rounded-lg overflow-hidden">
              <img
                src={images.grid4}
                className="w-full h-full object-cover"
                alt=""
              />
              <div className="p-2 absolute inset-0 flex flex-col gap-5  pl-4">
                <div>
                  <h2 className="text-xl font-bold">Summer's hottest hits</h2>
                  <p>Black & Unlimited music lagends</p>
                </div>
                <div>
                  <a className="underline">Shop now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative rounded-lg overflow-hidden">
          <img
            src={images.grid5}
            className="w-full h-full object-cover"
            alt=""
          />
          {/* text */}
          <div className="p-2 absolute text-white inset-0 flex flex-col justify-between w-[40%] pl-4">
            <div className="flex flex-col md:gap-5 gap-2">
              <h2 className="text-xl font-bold">
                Black & Unlimited summer favorites
              </h2>
              <div>
                <a className="underline">Shop now</a>
              </div>
            </div>
            <div className="flex flex-col font-bold">
              <div className="mb-[-10px]">From</div>
              <div className="flex items-center">
                <span className="md:text-2xl mb-4">$</span>
                <span className="md:text-6xl text-3xl">8</span>
                <span className="md:text-2xl mb-4">97</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* videos */}

      <div className="area">
        <div className="flex flex-col gap-1 my-4">
          <div className="font-bold text-2xl ">Featured in videos</div>
          <div className="text-sm text-[#656565]">
            See what creators are sharing
          </div>
        </div>
        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={30}
          slidesPerView="auto"
          slidesPerGroupAuto
          className="mySwiper"
          id="videoswiper"
        >
          {videoProducts.map((p, i) => (
            <SwiperSlide key={i} className="md:max-w-[370px] max-w-[270px]">
              <VideoCard {...p} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* shop deals */}

      <div className="area">
        <div className="space-y-1 my-4">
          <div className="font-bold text-2xl ">Show your HBCU pride</div>
          <div className=" text-sm text-[#656565]">
            Major school spirit vibes.
          </div>
        </div>
        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={30}
          slidesPerView="auto"
          slidesPerGroupAuto
          className="mySwiper"
        >
          {products.map((p, i) => (
            <SwiperSlide key={i} style={{ width: "220px" }}>
              <ProductCard {...p} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <Footer />
    </>
  );
};

export default Home;
